<template>
   <info-icon color="secondary" size="small"
      :content="content"
      style="cursor: pointer;"
      v-tippy
   />
</template>

<script>
import InfoIcon from '../../../atoms/Home/InfoIcon';

export default {
   name: 'layer-info-icon',
   components: {
      InfoIcon,
   },
   props: {
      source: {
         type: String,
         required: true,
      },
      description: {
         type: String,
         required: true,
      }
   },
   computed: {
      content()
      {
         return `
            <div class='layer-info-tip'>
               <strong>Source: </strong><span>${this.source || 'N/A'}</span><br>
               <strong>Description: </strong><span>${this.description || 'N/A'}</span>
            </div>`;
      }
   }
}
</script>

<style lang="scss">
.layer-info-tip {
   text-align: left;
   strong, span {
      font-family: $primary-font;
      color: $font-color;
      font-size: 14px;
   }
}
</style>